import _ from "lodash";

export const TransactionTypeDroOpts = () => {
    const TYPE  = {
        OPENING: "Opening",
        PAYMENT: "Payment",
        DEPOSIT: "Deposit",
        CLOSURE: "Closure"
    };   

    const getTransactionTypeModel = () => {
        let ret = TYPE;

        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: key, value: value }
                )
            ) ?? [])];
    }

    return {
        getTransactionTypeModel
    }
}